import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { RecalculatePremiumClientResponse } from '../@types/RecalculatePremium'

type Store = {
  recalculatePremium: RecalculatePremiumClientResponse | null
  setRecalculatePremium: (
    recalculatePremium: RecalculatePremiumClientResponse,
  ) => void
}

export const useRecalculatePremiumStore = create<Store>()(
  devtools(
    (set) => ({
      recalculatePremium: null,
      setRecalculatePremium: (recalculatePremium) =>
        set({ recalculatePremium }),
    }),
    { name: 'RecalculatePremiumStore' },
  ),
)
